
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[handle]",
      function () {
        return require("private-next-pages/work/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[handle]"])
      });
    }
  